export default {
  //Admin button style variants 
  // (to match the grad effects of the project variants) 
  // ==========================================================
  admin_primary: 
    "h-[40px] flex items-center justify-center bg-gradient-to-t from-grad_blue_dk to-grad_blue_lt text-white text-[16px] font-semibold hover:bg-gradient-to-t hover:from-admin_primary hover:to-admin_secondary rounded-full py-2 px-4 transition duration-200",
  
  admin_primary_red:
    "h-[40px] flex items-center justify-center bg-admin_error hover:bg-gradient-to-t hover:from-admin_error hover:to-white/30 text-white font-semibold rounded-full py-2 px-4 transition duration-200 ease-in-out",


  //Mobilingo Button Variants=====================================

  // Primary variants
  // 66px, test smaller size, large with icon 
  primary_xl:
    "w-auto h-[66px] flex items-center justify-center gap-[14px] bg-gradient-to-t from-grad_blue_dk to-grad_blue_lt text-white text-[18px] md:text-[20px] lg:text-[22px] font-semibold hover:bg-gradient-to-t hover:from-primary hover:to-secondary rounded-full px-[20px] xl:px-[30px] transition duration-200",

  // 62px (test smaller size)
  primary_l: 
    "w-auto h-[50px] md:h-[56px] lg:h-[62px] flex items-center justify-center gap-[14px] bg-gradient-to-t from-grad_blue_dk to-grad_blue_lt text-white text-[18px] md:text-[20px] lg:text-[22px] font-semibold hover:bg-gradient-to-t hover:from-primary hover:to-secondary rounded-full px-[20px] md:px-[24px] lg:px-[30px] transition duration-200",

  // 66px
  primary_m: 
    "w-auto h-[50px] md:h-[58px] lg:h-[66px] flex items-center justify-center gap-[14px] bg-gradient-to-t from-grad_blue_dk to-grad_blue_lt text-white text-[18px] md:text-[20px] lg:text-[22px] font-semibold hover:bg-gradient-to-t hover:from-primary hover:to-secondary rounded-full px-[16px] md:px-[18px] lg:px-[20px] transition duration-200",

  // 46px
  primary_s: 
    "w-auto h-[40px] md:h-[44px] xl:h-[46px] flex items-center justify-center gap-[14px] bg-gradient-to-t from-grad_blue_dk to-grad_blue_lt text-white text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] font-semibold hover:bg-gradient-to-t hover:from-primary hover:to-secondary rounded-full px-[16px] md:px-[18px] lg:px-[20px] transition duration-200",
 
  // 46px disabled
  primary_s_disabled: 
    "w-auto h-[40px] md:h-[44px] xl:h-[46px] flex items-center justify-center gap-[14px] text-secondary text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] font-semibold rounded-full px-[16px] md:px-[18px] lg:px-[20px] xl:px-[20px] border-[1px] border-secondary cursor-not-allowed",

    // 62px (TT page CTA button)
    primary_tt_l: 
    "w-auto h-[62px] flex items-center justify-center gap-[14px] bg-blue_tt text-white text-[22px] font-semibold hover:bg-gradient-to-t hover:from-[#DD4265]/50 hover:to-blue_tt rounded-full px-[30px] transition duration-200",
  
  primary_FAB:
    "h-[66px] md:h-[74px] xl:h-[82px] flex items-center justify-center gap-[10px] bg-gradient-to-t from-grad_blue_dk to-grad_blue_lt text-white text-[20px] md:text-[22px] lg:text-[24px] xl:text-[26px] leading-tight font-semibold hover:bg-gradient-to-t hover:from-primary hover:to-secondary rounded-full px-[26px] transition duration-200",

  // Secondary variants
  // 62px (test smaller size)
  secondary_l:
    "w-auto h-[50px] md:h-[56px] lg:h-[62px] flex items-center justify-center border-[1px] border-primary hover:border-primary_lt text-primary hover:text-white text-[18px] md:text-[20px] lg:text-[22px] font-semibold rounded-full px-[20px] md:px-[24px] lg:px-[30px] hover:bg-gradient-to-t from-grad_blue_dk to-grad_blue_lt transition duration-200",

  // 56px
  secondary_m:
    "w-auto h-[40px] md:h-[48px] lg:h-[56px] flex items-center justify-center border-[1px] border-primary hover:border-primary_lt text-primary hover:text-white text-[18px] md:text-[20px] lg:text-[22px] font-semibold rounded-full px-[16px] md:px-[18px] lg:px-[20px] hover:bg-primary transition duration-200", 

  // 44px
  secondary_s:
    "w-auto h-[40px] lg:h-[44px] flex items-center justify-center border-[1px] border-primary hover:border-primary_lt text-primary hover:text-white text-[17px] font-semibold rounded-full px-[16px] md:px-[18px] lg:px-[20px] hover:bg-primary box-border transition duration-200",  

  // Error/Delete buttons
  // 44px
  error_m:
    "w-auto h-[40px] lg:h-[44px] text-[17px] text-error hover:text-white hover:bg-error font-semibold rounded-full px-5 border border-error transition duration-200",

  error_s:
    "w-auto h-[34px] text-[15px] text-error hover:text-white hover:bg-error font-semibold rounded-full px-5 border border-error transition duration-200",

  // Text button variants
  text_btn_primary_m:
    "text-primary text-[20px] leading-tight font-semibold hover:bg-clip-text hover:text-transparent hover:bg-gradient-to-t hover:from-primary hover:to-secondary transition duration-200",
   
  text_btn_primary_s:
    "text-primary text-[15px] leading-tight font-semibold hover:bg-clip-text hover:text-transparent hover:bg-gradient-to-t hover:from-primary hover:to-secondary transition duration-200",

  //Text_btn in gray version (for help links, etc.)
  text_btn_ghost:
    "text-gray_700 hover:text-gray_900 text-[15px] leading-tight font-normal transition duration-200",

  // Footer and navbar navigation - menuItems
  nav_menuitem:
    "text-[17px] xl:text-[18px] text-left leading-tight font-normal text-text hover:text-primary transition duration-200",  

  // Navigation variants
  nav_icon:
    "w-[49px] h-[49px] md:w-[69px] md:h-[69px] flex items-center justify-center rounded-full hover:bg-gray_100 border border-gray_500 hover:border-gray_100 text-text text-[14px] md:text-[20px] font-normal transition duration-200",

  // Sign in with Apple / Google - general button (bg-colors and platform icons to be assigned per case)
  sign_in_option:
    "w-full max-w-[374px] rounded-full py-[14px] px-[30px] flex items-center justify-center gap-[6px] text-white text-[14px] sm:text-[16px] md:text-[18px] xl:text-[20px] leading-tight font-semibold hover:bg-opacity-90 transition duration-200",

  sign_in_option_disabled:
    "w-full max-w-[374px] rounded-full py-[14px] px-[30px] flex items-center justify-center gap-[6px] text-secondary text-[14px] sm:text-[16px] md:text-[18px] xl:text-[20px] leading-tight font-semibold border-[1px] border-secondary cursor-not-allowed",

    // Platform buttons
    platform_l_black:
    "w-[220px] h-[65px] rounded-[12px] flex items-center justify-center transition duration-200",
    platform_m_black:
    "w-[160px] lg:w-[190px] h-[46px] lg:h-[55px] rounded-[12px] flex items-center justify-center transition duration-200",
    platform_m_outlined:
    "w-[190px] h-[55px] border border-gray-200 hover:border-gray-900 rounded-[12px] flex items-center justify-center transition duration-200",


 

  //NOT UPDATED YET----------------------------------------------
  
  // Social button variants
  social:
    "w-10 h-10 rounded-full flex items-center justify-center hover:text-primary transition duration-200",
  social_active:
    "w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center",

  // Switch button (for the Teams/Individual toggle)
  switch: "bg-neutral-100 rounded-full px-6 py-2 flex gap-4 w-fit",
  switch_option: "px-4 py-2 rounded-full transition duration-200",
  switch_option_active:
    "px-4 py-2 rounded-full bg-primary text-white transition duration-200",
}
